module.exports = __webpack_public_path__ + "img/害羞.56d02019.png";